import {
  aCategory,
  aSignalPage,
  mockSignalsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { SIGNAL_FRAGMENT } from '@sbu/configs.mocks';

export const signalsListResponse = {
  __typename: 'Query',
  signals: {
    ...aSignalPage(),
    objects: [{ ...SIGNAL_FRAGMENT }],
  },
  categories: [aCategory()],
};

export const handlers = [
  mockSignalsQueryOperationQuery(async ({ query: _query, variables }) => {
    await delay(1500);
    const query = variables.q;

    // Filtering by content type
    const contentType = query?.match(/contentType:"([^"]+)"/)?.[1];

    return HttpResponse.json({
      data: {
        __typename: 'Query',
        signals: {
          ...aSignalPage(),
          objects: [
            // @ts-ignore contentTypeEnum is aliased which causes issues with typing since MSW doesn't handle this case
            { ...SIGNAL_FRAGMENT, ...(contentType ? { contentType } : {}) },
          ],
        },
        categories: [aCategory()],
      },
    });
  }),
];
